exports.OrderState = {
  Confirmation: "CONFIRMATION",
  Preparation: "PREPARATION",
  Distribution: "DISTRIBUTION",
  Delivered: "DELIVERED",
  Cancelled: "CANCELLED",
};
